"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Rating = /*#__PURE__*/function (_Component) {
  _inherits(Rating, _Component);

  var _super = _createSuper(Rating);

  function Rating() {
    var _this;

    _classCallCheck(this, Rating);

    _this = _super.call(this, {
      keyboardFocusOnly: true
    });
    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_this));
    _this.onStarMouseEnter = _this.onStarMouseEnter.bind(_assertThisInitialized(_this));
    _this.onStarMouseDown = _this.onStarMouseDown.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.state = {
      hoverIndex: 0,
      value: 0,
      maxValue: 5
    };
    return _this;
  }

  _createClass(Rating, [{
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.setState({
        value: value,
        hoverIndex: value
      });
      this.props.onChange(value);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        hoverIndex: 0
      });
    }
  }, {
    key: "onStarMouseEnter",
    value: function onStarMouseEnter(index) {
      this.setState({
        keyboardFocus: false
      });
      this.setState({
        hoverIndex: index
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        keyboardFocus: this.focusedViaKeyboard
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        hoverIndex: 0,
        keyboardFocus: false
      });
    }
  }, {
    key: "onStarMouseDown",
    value: function onStarMouseDown(index) {
      this.setState({
        keyboardFocus: false
      });
      this.setValue(index);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      switch (event.key) {
        case 'ArrowRight':
          {
            // setting initial value inside onFocus doesn't cover the case where
            // a star is clicked, mouse leaves (resettings the hoverIndex) and then arrows are used
            var hoverIndex = this.state.hoverIndex || this.state.value || 1;

            if (hoverIndex < this.state.maxValue) {
              this.setState({
                hoverIndex: hoverIndex + 1
              });
            }

            break;
          }

        case 'ArrowLeft':
          {
            var _hoverIndex = this.state.hoverIndex || this.state.value || 1;

            if (_hoverIndex > 1) {
              this.setState({
                hoverIndex: _hoverIndex - 1
              });
            }

            break;
          }

        case "Enter":
          {
            if (this.state.hoverIndex) {
              this.setValue(this.state.hoverIndex);
            }

            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.state.keyboardFocus && this.addClass('lth-has-keyboardfocus');
      var value = this.props.value || this.state.value;
      var stars = Array(this.state.maxValue).fill(null).map(function (v, index) {
        var starClassNames = [_this2.constructor.BASE_CLASS + '__star'];
        var color = 'var(--rating-star-regular-color)';

        if (_this2.props.disabled) {
          color = 'var(--rating-star-disabled-color)';
        } else {
          if (_this2.state.hoverIndex > 0) {
            if (index < _this2.state.hoverIndex) {
              color = 'var(--rating-star-hover-color)';
            }

            if (index === _this2.state.hoverIndex - 1) {
              starClassNames.push('lth-is-focus-target');
            }
          } else {
            if (value > index) {
              color = 'var(--rating-star-selected-color)';
            }

            if (index === value - 1 || !value && !index) {
              starClassNames.push('lth-is-focus-target');
            }
          }
        }

        var props = {
          className: starClassNames.join(' '),
          onMouseEnter: function onMouseEnter() {
            return _this2.onStarMouseEnter(index + 1);
          },
          onMouseDown: function onMouseDown() {
            return _this2.onStarMouseDown(index + 1);
          },
          key: index
        };
        return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement(_.Icon, {
          icon: "starFilled",
          color: color,
          size: 20,
          index: index
        }));
      });
      var starsProps = {
        className: this.constructor.BASE_CLASS + '__stars',
        onMouseLeave: this.onMouseLeave,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        tabIndex: 0
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, /*#__PURE__*/_react.default.createElement(_.Label, {
        disabled: this.props.disabled
      }, this.props.label), /*#__PURE__*/_react.default.createElement("div", starsProps, stars));
    }
  }]);

  return Rating;
}(_component.default);
/*---------------------------------------------*/


exports.default = Rating;

_defineProperty(Rating, "BASE_CLASS", 'lth-c-rating');

Rating.METADATA = {
  name: 'Rating',
  props: [{
    name: 'label',
    type: 'string',
    default: 'Rating label',
    description: 'Label'
  }, {
    name: 'value',
    type: 'number',
    options: [{
      value: 1
    }, {
      value: 2
    }, {
      value: 3
    }, {
      value: 4
    }, {
      value: 5
    }]
  }, {
    name: 'disabled',
    type: 'boolean',
    default: false
  }, {
    name: 'onChange',
    type: 'function',
    description: 'Callback function called after the value is changed'
  }]
};